import React from "react";
import Img, { IImgProps } from "./Img";
import getKenticoImageSrc from "utils/getKenticoImageSrc";

interface IProps extends IImgProps {
    widthFactor?: number;
}

function getSrcSetForWidths(src: string, widths: number[], widthFactor: number = 1) {
    return widths
        .map((width) => `${getKenticoImageSrc(src, width / widthFactor)} ${width}w`)
        .join(", ");
}

export default function KenticoImg(props: IProps) {
    const placeholderImageSize = 150;

    const {
        src,
        widthFactor,
        placeholder = getKenticoImageSrc(src, placeholderImageSize),
        srcSet = getSrcSetForWidths(
            src,
            [400, 600, 800, 1000, 1200, 1400, 1600, 1800, 2000],
            widthFactor
        ),
        ...rest
    } = props;

    return <Img src={placeholder} placeholder={placeholder} srcSet={srcSet} {...rest} />;
}
